import $ from "jquery";

function TicketSelectSubmit() {
  $(".js-ticket-select").on("change", function () {
    let hasValue = false;

    // １以上の値が選択されたかどうかチェック
    $(".js-ticket-select").each(function () {
      $(this)
        .find("option:selected")
        .each(function () {
          if ($(this).val() >= 1) {
            hasValue = true;
          }
        });
    });

    // ボタン非活性制御
    if (hasValue) {
      $(".js-ticket-submit-button").attr("aria-disabled", false);
    } else {
      $(".js-ticket-submit-button").attr("aria-disabled", true);
    }
  });
}

export { TicketSelectSubmit };
